// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__3B2aX","unreadBadge":"styles_unreadBadge__3-uct","modalContent":"styles_modalContent__2Nza7","modal":"styles_modal__2drE6"};